<script setup lang="ts">
import { computed } from 'vue';

interface Props {
	value: string | number;
	label: string;
}

const { value = 0, label = '' } = defineProps<Props>();

const symbolsCount = computed(() => value.toString().length);
const fontScale = computed(() => 1 - Math.max(symbolsCount.value - 3, 0) * 0.08);
//const fontScale = computed(() => 1 - Math.max(symbolsCount.value, 0) * 0.08);
const baseFontSize = computed(() => 40 * fontScale.value);
//const svgWidth = computed(() => 100 * fontScale.value);
const svgWidth = computed(() => Math.max(140, symbolsCount.value * 20)); // Dynamic width based on content
const svgHeight = computed(() => baseFontSize.value + 35 + 20);
</script>

<template>
	<svg
		:style="{
			fontFamily: 'Cairo, Arial',
			fontWeight: 900,
			textAlign: 'center',
			width: 'auto',
			height: '100%'
		}"
		:viewBox="`0 -10 ${svgWidth} ${svgHeight}`"
		xmlns="http://www.w3.org/2000/svg"
	>
		<text
			text-anchor="middle"
			fill="#4C3D11"
			stroke="#8B7E4E"
			stroke-linejoin="round"
			paint-order="stroke"
			stroke-width="1.5"
			font-size="25"
			x="50%"
			:y="baseFontSize + 25"
		>
			{{ label }}
		</text>
		<text
			text-anchor="middle"
			font-weight="700"
			fill="#4C3D11"
			stroke="#8B7E4E"
			:stroke-width="1.5"
			stroke-linejoin="round"
			paint-order="stroke"
			:font-size="baseFontSize"
			x="50%"
			:y="baseFontSize"
		>
			{{ value }}
		</text>
	</svg>
</template>
